import $ from 'jquery';
import QuoteApi from './QuoteApi';
import WorkSearch from './WorkSearch';
import openBasket from './open-basket';
import EventBus from '../../common/EventBus';

export const WORK_TYPES = {
  repair: 'repair',
  service: 'service',
  inspection: 'inspection',
  diagnostic: 'diagnostic',
  unknownProblem: 'unknown-problem',
};

const VALID_WORK_TYPES = [
  WORK_TYPES.repair,
  WORK_TYPES.service,
  WORK_TYPES.inspection,
  WORK_TYPES.diagnostic,
  WORK_TYPES.unknownProblem,
];

const SELECTORS = {
  workPageContent: '.work-page-content',
  workNavigation: '.js-work-navigation',
  workSectionLink: '.js-work-section-link',
  searchResults: '.search-results',
  tyreFitting: '.js-tyre-fitting',
  search: '.search',
  searchInput: '#search-input',
  workTypeSelect: '.work-type-select',
  workSection: '.js-work-section',
  modal: '.modal',
  inspectionPanel: '.v2-inspection-panel',
  popularRepairsContainer: '.popular-repairs-container',
  relevantRepairsContainer: '.relevant-repairs-container',
  fixedHeader: '.fixed-header',
  repairCategoryTree: '.repair-category-tree',
  repairCategory: '.js-repair-category',
  browseByCategory: '.browse-by-category',
  mobileTabs: '.v2-mobile-repair-tabs',
};

const CSS_CLASSES = {
  hidden: 'hidden',
  active: 'active',
  show: 'show',
};

const EVENTS = {
  beginSearchState: 'begin-search-state',
};

export default class WorkPageNav {
  constructor(workPage) {
    this.workType = this._workTypeFromState();
    this.workPageContent = $(SELECTORS.workPageContent);
    this.quoteApi = new QuoteApi();
    this.workPage = workPage;
    this.workSearch = new WorkSearch();
    this.init();
  }

  init() {
    if (VALID_WORK_TYPES.indexOf(this.workType) !== -1) {
      this._showWorkSection(this.workType);
      this._updateNav(this.workType);
    }

    $(SELECTORS.workNavigation).on('click', 'li', (e) => {
      this._enableWorkSection($(e.currentTarget));
    });

    $(SELECTORS.workSectionLink).on('click', (e) => {
      this._enableWorkSection($(e.currentTarget));
      $(window).scrollTop(0);
    });

    $(SELECTORS.searchResults).on('click', SELECTORS.tyreFitting, () => {
      this._enableWorkSection($(SELECTORS.tyreFitting));
    });

    $(SELECTORS.searchResults).on(EVENTS.beginSearchState, () => {
      $(SELECTORS.tyreFitting).prop('disabled', false);
    });
  }

  updatePageUsingState(state) {
    if (state.work_type) {
      this._displayWorkType(state.work_type);

      if (state.work_type === WORK_TYPES.inspection || state.work_type === WORK_TYPES.unknownProblem) {
        this._updateInspectionPanels(state.inspection_panel_stack);
      }
      if (state.work_type === WORK_TYPES.repair) {
        this._updatePopularRepairsContainer() || this._displayRepairCategory(state.cat);
        if (state.focus_search) {
          setTimeout(function () {
            $(SELECTORS.searchInput).focus();
          }, 0);
        }
      }

      if (state.search) {
        this._displaySearch();
      }
    } else if (state.auto_open_basket) {
      openBasket();
    } else {
      $(SELECTORS.workPageContent).addClass(CSS_CLASSES.hidden);
      $(SELECTORS.workTypeSelect).removeClass(CSS_CLASSES.hidden);
    }

    this._checkForSearchResults(state);

    const openModal = $(`${SELECTORS.modal}.${CSS_CLASSES.show}`);
    if (openModal.length) {
      window.Application.close_modal(openModal); // Close modal stays on window
    }

    this._autoOpenModal(state.auto_open_modal);
  }

  _displayWorkType(workType) {
    $(SELECTORS.workTypeSelect).addClass(CSS_CLASSES.hidden);
    this.workPageContent.removeClass(CSS_CLASSES.hidden);

    this._showWorkSection(workType);
    EventBus.emit('work:section-changed', { workType: workType });
    if (workType === WORK_TYPES.repair) {
      $(SELECTORS.search).removeClass(CSS_CLASSES.hidden);
    } else {
      $(SELECTORS.search).addClass(CSS_CLASSES.hidden);
    }
  }

  _displaySearch() {
    $(SELECTORS.search).removeClass(CSS_CLASSES.hidden);
    $(SELECTORS.workSection).addClass(CSS_CLASSES.hidden);
  }

  _updateInspectionPanels(inspectionPanelStack) {
    const firstPanel = $(SELECTORS.inspectionPanel).eq(0);
    const panels = inspectionPanelStack || [firstPanel.data('inspection-panel-id')];
    $(SELECTORS.inspectionPanel).addClass(CSS_CLASSES.hidden);
    $('.' + panels.pop()).removeClass(CSS_CLASSES.hidden);
    $(window).scrollTop(0);
  }

  _updatePopularRepairsContainer() {
    if ($(`${SELECTORS.relevantRepairsContainer}:visible`).length) {
      const headerHeight = $(SELECTORS.fixedHeader).height();
      const isMobile = $(SELECTORS.relevantRepairsContainer).data('is-mobile');
      if (isMobile) {
        $(window).scrollTop($(SELECTORS.relevantRepairsContainer).offset().top - headerHeight);
      }
      $(SELECTORS.popularRepairsContainer).addClass(CSS_CLASSES.hidden);
      return true;
    }
  }

  _displayRepairCategory(category) {
    if (category) {
      const categoryToActivate = $(`${SELECTORS.repairCategory}[data-repair-category="${category}"]`);
      if (categoryToActivate.length) {
        $(SELECTORS.repairCategoryTree).removeClass(CSS_CLASSES.hidden);
        $(window).scrollTop($(SELECTORS.browseByCategory).position().top - 10);
        EventBus.emit('repair-category:activate', { category: category, element: categoryToActivate });
      }
    }
  }

  _checkForSearchResults(state) {
    if (state.search) {
      this.workSearch.showResults(state.results);
      this.workPage.updateButtonStates();
    } else {
      this.workSearch.hideResults();
    }
  }

  _autoOpenModal(modalId) {
    if (!modalId) return;

    const modal = $('div').find(`div${SELECTORS.modal}#${modalId}`);
    if (!modal.length) return;

    const workTypeContainer = modal.closest(SELECTORS.workSection);
    if (workTypeContainer.hasClass(CSS_CLASSES.hidden)) return;

    setTimeout(() => {
      window.Application.display_modal(modal);
    });
  }

  _enableWorkSection(target) {
    const workType = target.data('work-type');
    History.pushState({ work_type: workType }, '', '?type=' + workType);

    this._updateNav(workType);
    target.addClass(CSS_CLASSES.active);
    this._showWorkSection(workType);
    EventBus.emit('work:section-changed', { workType: workType });
  }

  _showWorkSection(workType) {
    $(SELECTORS.workSection).addClass(CSS_CLASSES.hidden);
    $(`${SELECTORS.workSection}[data-work-type="${workType}"]`).removeClass(CSS_CLASSES.hidden);
  }

  _updateNav(workType) {
    const position = $(`li[data-work-type="${workType}"]`).position();
    // Scroll mobile navigation to have the selected item in view.
    if (position) {
      $(SELECTORS.mobileTabs).scrollLeft(position.left);
    }
    $(SELECTORS.workNavigation).children('li').removeClass(CSS_CLASSES.active);
    $(SELECTORS.workNavigation)
      .find(`li[data-work-type="${workType}"]`)
      .addClass(CSS_CLASSES.active);
  }

  _workTypeFromState() {
    let workType = History.getState().data.work_type;
    if (!workType) workType = new URLSearchParams(window.location.search).get('type');
    if (!workType) workType = WORK_TYPES.repair;
    return workType;
  }
}
